module.exports = __webpack_public_path__ + "static/tastytrade-aus-fsg-5fef4e4504eb6535a5a2b82e67d30ee4.pdf";